import swal from 'sweetalert';

export default {
  methods: {
    /**
     * @param {string} msg
     * @param {string} group
     */
    notificar(text, group, type = 'warn') {
      this.$notify({
        group,
        title: 'Atenção!',
        text,
        type
      });
    },

    customAlert(title = 'Atenção', text = '', icon = 'success') {
      swal({
        title: title,
        text: text,
        icon: icon,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/mixins/utils.js